import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

const RefreshIcon = ({ loading, onClick }) => {
  if (loading) {
    return <FontAwesomeIcon icon={faSync} spin fixedWidth />;
  }
  return <FontAwesomeIcon icon={faSync} fixedWidth onClick={onClick} />;
};

RefreshIcon.propTypes = {
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const dummy = {};

export { RefreshIcon, dummy };
